import { RecoverableTerminalErrorStatus } from '@afterpay/types'
import { Loader } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { ReactElement, useEffect } from 'react'

import { Head, ModuleContainer, RecoverableTerminalError } from '../../../src/component'
import { Route } from '../../../src/config/router'
import { CheckoutPage } from '../../../src/model'
import { useAppRouter, useCheckoutError, useIsRecoverableFlowPageReady, useRecoverableTerminalErrorsState } from '../../../src/state'
import { TrackPageViewed } from '../../../src/integrations/monitoring'

export const OhNoErrorPage: CheckoutPage = (): ReactElement => {
  const { t } = useTranslation()
  const checkoutError = useCheckoutError()
  const pageTitle = t([`recoverableTerminalError:${checkoutError?.error ?? ''}.head`, 'recoverableTerminalError:default.heading'])
  const { status } = useRecoverableTerminalErrorsState()
  const router = useAppRouter()
  const isPageReady = useIsRecoverableFlowPageReady()

  useEffect(() => {
    if (status === RecoverableTerminalErrorStatus.LackOfEligibleOrders) {
      router.replace(Route.TERMINAL_ERROR)
    }
  }, [status, router])

  return (
    <>
      <Head title={pageTitle} />
      {!isPageReady && (
        <ModuleContainer padding={{ vertical: 'Large', horizontal: 'XLarge' }}>
          <Loader />
        </ModuleContainer>
      )}
      <RecoverableTerminalError {...checkoutError} />
      <TrackPageViewed eventProperties={{ limitExceeded: checkoutError?.errorCode }} />
    </>
  )
}
